/**
 * Which of the parent's devices have a current action waiting for the parent's Approve
 * (status/currentAction/state == 'awaitingApproval', BA-58). Read-only RTDB listeners,
 * one per device, so the dots in DashboardLayout show on every page.
 */

import { useEffect, useState } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../firebase';

export function useWaitingDevices(deviceIds: string[]): string[] {
  const [waiting, setWaiting] = useState<Record<string, boolean>>({});
  // A stable dependency: the same ids in the same order do not re-subscribe
  const key = deviceIds.join('|');

  useEffect(() => {
    const ids = key ? key.split('|') : [];
    setWaiting({});
    const unsubscribes = ids.map((id) =>
      onValue(
        ref(database, `/devices/${id}/status/currentAction/state`),
        (snapshot) => {
          const isWaiting = snapshot.val() === 'awaitingApproval';
          setWaiting((prev) => (prev[id] === isWaiting ? prev : { ...prev, [id]: isWaiting }));
        },
        (err) => console.error('Error listening to currentAction state:', err)
      )
    );
    return () => unsubscribes.forEach((unsubscribe) => unsubscribe());
  }, [key]);

  return deviceIds.filter((id) => waiting[id]);
}
